export const getQuestionnaireLink = (link) => link.endsWith('/filter')
    ? `${link}?guidedQuestionnaire=true`
    : `${link}/filter?guidedQuestionnaire=true`;
//# sourceMappingURL=getQuestionnaireLink.js.map